module.exports = __webpack_public_path__ + "static/img/4en.f9b8969.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/4en.png
// module id = C6Ba
// module chunks = 0